/**
 * May this caller read escalations at all?
 *
 * FOUR PERMISSIONS, NOT ONE, mirroring `EscalationPolicy::mayRead()` on the
 * server — and the last two are why this helper exists rather than an
 * inline `includes('escalation.view')`.
 *
 * `escalation.view` is not a role permission. M-01 made it directly
 * grantable, because it is where the legacy's per-user `viewEscalation`
 * flag landed, so NO role grants it — not even administrator. Gating a
 * nav entry, a route, or a panel on it alone hid the whole feature from
 * every account that had not been individually flagged, including the demo
 * administrator. That is how this was first found: the entry simply was
 * not in the sidebar (`App.tsx`'s `canReadEscalations`, before this file
 * existed).
 *
 * `escalation.act` was added after that first fix, once whole-branch review
 * (finding I-1) established that the `educator` role is granted
 * `escalation.act` and nothing else, while `ChainRouter` routes work to
 * educators and notifies them (spec E-6). An educator holding only
 * `escalation.act` could never open the escalation assigned to them without
 * this fourth permission in the rule.
 *
 * THIS IS THE ONLY PLACE THIS RULE MAY LIVE. It shipped inline in `App.tsx`
 * for the nav entry, was copied into `CaseDetail.tsx` as a truncated
 * one-permission version for the case-detail panel (finding C-1, exactly
 * the defect this file exists to prevent from recurring a third time), and
 * is now imported by both. If the client and the server
 * (`EscalationPolicy::mayRead()`) ever disagree, the symptom is a nav entry
 * or panel that 403s, or a screen nobody can reach — so keep this list in
 * step with the server's.
 */
export function canReadEscalations(permissions: readonly string[]): boolean {
  return (
    permissions.includes('escalation.view') ||
    permissions.includes('escalation.manage') ||
    permissions.includes('escalation.create') ||
    permissions.includes('escalation.act')
  );
}
